<template>
  <span v-if="wording && wording[submission_id] && wording[submission_id][area] && wording[submission_id][area][textkey]" v-html="wording[submission_id][area][textkey]">
  </span>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    props: ['submission_id', 'area', 'textkey'],
    name: "Speaker",
    computed: mapState([
      'wording'
    ])
  }
</script>

<style scoped>

</style>
